<template>
  <div>
    <app-loading :isFull="true" v-if="isLoading"/>
    <div class="container-fluid">
      <div class="row">
        <div class="col-12">
          <div class="mb-5 bg-white font-14" v-if="lists.length">
            <b-table stacked="lg" :fields="fieldsItems" :items="lists" class="text-center">
              <template  v-slot:cell(callbackCode)="row">
                <!-- <div :class="[{'table-success':row.item.callbackCode == 0 , 'table-danger':row.item.callbackCode !== 0}]"> -->
                {{row.item.callbackCode == 0? 'پرداخت موفق' : 'پرداخت ناموفق'}}
                <!-- </div> -->
              </template>
              <template v-slot:cell(date)="row" >
                <p class="mb-0">{{row.item.date | date}}</p>
              </template>
              <template v-slot:cell(amount)="row" >
                <p class="mb-0">{{row.item.amount | currency}}</p>
              </template>
              <template v-slot:cell(all)="row">
                <ul
                  class="f-flex flex-column"
                  v-for="(item,index) in row.item.courses"
                  :key="index"
                >
                  <li class="border-0 p-1 font-12">
                    <router-link
                      class="d-block"
                      :to="'/courses/'+item.en_category +'/'+ item.en_subcategory +'/'+ item.course_id + '/' + item.course_title_en"
                    >{{item.course_title}}</router-link>
                  </li>
                </ul>
              </template>
            </b-table>
          </div>
        </div>
      </div>
    </div>
    <page-number :lengthList="lengthList" @callBack="getAllBillReuslt"/>
  </div>
</template>

<script>
export default {
  name: 'component-list-transaction',
  data() {
    return {
      isLoading: false,
      page: 1,
      fieldsItems: [
        { key: 'all', label: ' دوره ها' },
        { key: 'user_fullname', label: ' نام خریدار' },
        { key: 'date', label: 'تاریخ',sortable: true },
        { key: 'amount', label: 'هزینه' ,sortable: true},
        { key: 'order_id', label: 'شماره سفارش' },
        { key: 'transaction_number', label: 'شماره تراکنش' },
        { key: 'offerCodeText', label: ' کد تخفیف' ,sortable: true},
        { key: 'offerPercent', label: ' درصد تخفیف' ,sortable: true},
        {          key: 'callbackCode',
          label: ' نتیجه تراکنش',
          sortable: true,
          tdClass: (value, key, item) => {
            return item.callbackCode === 0 ? 'font-12 table-success' : 'font-12 table-danger'
          }
        }
      ]
    }
  },
  computed: {
    lists() {
      return this.$store.state.Daccounting.listAllTransaction
    },
    lengthList() {
      return this.$store.state.Daccounting.listAllTransactionLengthList
    }
  },
  methods: {
    async getAllBillReuslt(p) {
      this.isLoading = true
      await this.$store.dispatch('Daccounting/getLstAllTransaction', { p })
      this.isLoading = false
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/dashboard-component/my-payment/list-transaction-all.vue